export const getAnalytics = (): SegmentAnalytics.AnalyticsJS & {
  initialized?: boolean
} => global.analytics
